import type { HandleEventProps } from '@lyearn/lygo-blocks';
import { EditorState } from '@lyearn/lygo-core';
import { KeyCodes } from '@/consts/keyCodes';
import { isSubmitEvent } from '@/utils/events';

const EMPTY_DOC_SIZE = 5;

const onEditorKeyDown: HandleEventProps['onKeyDown'] = (editorView, event) => {
  if (isSubmitEvent(event)) {
    event.preventDefault();
    return true;
  }

  if (event.key === KeyCodes.Backspace) {
    const { from, to } = editorView.state.selection;
    const selectionSize = to - from || 0;
    const docSize = editorView.state.doc.nodeSize;

    const isAllContentSelected = docSize === selectionSize + EMPTY_DOC_SIZE;

    if (isAllContentSelected) {
      //triggers default update to addhacknode: https://github.com/ProseMirror/prosemirror-view/blob/128620ca6e68153f3e51ca13ceab358495767a0b/src/viewdesc.js#L1265
      //solves this issue: https://linear.app/lyearn/issue/BUG-2200/input-box-is-not-clickable-after-removing-content
      editorView.updateState(
        EditorState.create({ schema: editorView.state.schema, plugins: editorView.state.plugins }),
      );
    }
  }

  return false;
};

export default onEditorKeyDown;
